import React from 'react';
import { GtmSolutionUseCase } from '../../../types/go-to-market';
import { Product } from '../../../types/product';
import ArchitectureUseCaseCard from './ArchitectureUseCaseCard';


const ArchitectureUseCaseList: React.FC<{
  useCases: GtmSolutionUseCase[],
  productMap: Record<Product['id'], Product>,
}> = ({
  useCases,
  productMap
}) => {
  return (
    <>
      <h2>Use Cases</h2>
      {useCases && useCases.length > 0
        ? useCases.map((useCase) => (
            <ArchitectureUseCaseCard key={useCase.id} useCase={useCase} productMap={productMap} />
          ))
        : (
            <div className="italic text-gray-50">No use cases available for this architecture.</div>
          )
      }
    </>
  );
}

export default ArchitectureUseCaseList;